<template>
    <div class="form-group">
        <label>Kokoonpano</label>
        <multiselect
            @select="onSelect"
            :options="bandTypeOptions"
            :searchable="true"
            track-by="id"
            label="name"
            :options-limit="10"
            :allow-empty="false"
            placeholder="Valitse kokoonpano"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :show-no-results="false"
            :hide-selected="false"
            :value="selectedBandType"
        >
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedBandType',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            bandTypeOptions: {
                type: Array
            },
            selectedBandType: {
                type: Object,
                required: false
            }
        },
        methods: {
            onSelect(bandtype) {
                this.$emit('change', bandtype);
            }
        }
    };
</script>
